import type { PricingCatalogFeature } from 'app/services/pricingCatalog';

type ExploreSummaryFeature = {
  code: string;
  label: string;
  enabled: boolean;
};

export const formatExploreSummaryFeature = (
  feature: PricingCatalogFeature,
): ExploreSummaryFeature => ({
  code: feature.code,
  label: summaryLabelFor(feature),
  enabled: feature.availability !== 'unavailable',
});

const summaryLabelFor = (feature: PricingCatalogFeature): string => {
  switch (feature.code) {
    case 'jusfy_ai':
      if (feature.availability === 'unlimited') {
        return 'Mensagens ilimitadas na IA da Jusfy';
      }
      if (feature.availability === 'limited' && feature.value != null) {
        return `${feature.value} mensagens na IA da Jusfy`;
      }
      return feature.label;
    case 'legal_queries':
      if (feature.availability === 'limited' && feature.value != null) {
        return `${feature.value} consultas jurídicas`;
      }
      return feature.label;
    case 'legal_calculations':
      if (feature.availability === 'unlimited') {
        return 'Cálculos jurídicos ilimitados';
      }
      if (feature.availability === 'limited' && feature.value != null) {
        return `${feature.value} cálculos jurídicos`;
      }
      return feature.label;
    case 'prospecting':
      if (feature.availability === 'limited' && feature.value != null) {
        return `${feature.value} oportunidades de prospecção`;
      }
      return feature.label;
    case 'subusers':
      if (feature.availability === 'unavailable') {
        return 'Sem subusuários';
      }
      if (feature.availability === 'limited' && feature.value != null) {
        return `${feature.value} subusuários`;
      }
      return feature.label;
    case 'drive_storage':
      if (feature.availability === 'limited' && feature.value != null) {
        return `${feature.value} GB de armazenamento no Drive`;
      }
      return feature.label;
    default:
      return feature.label;
  }
};
